import React from 'react';
import Layout from '../components/Layout';
import InteractiveTab from '../components/InteractiveTab';
import challenge from '../assets/challenge.png';
import solution from '../assets/solution.png';
import outcome from '../assets/outcome.png';
import payan from '../assets/favicon.ico';

const BUTTONS = [
  {
    label: '3x',
    sub: 'engagement on<br/>chat & voice',
  },
  {
    label: '3x',
    sub: 'engagement on<br/>chat & voice',
  },
  {
    label: '3x',
    sub: 'engagement on<br/>chat & voice',
  },
];

const SuccessPage = () => (
  <Layout>
    {/* Section 1: Top half black, bottom half white */}
    <section
      className="w-full flex flex-col items-center justify-start"
      style={{
        minHeight: 1200,
        background: `linear-gradient(to bottom, #000 0%, #000 ${200/1200*100}%, #fff ${200/1200*100}%, #fff 100%)`,
      }}
    >
      <div className="w-full max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24 pt-16 pb-0 flex flex-col items-center">
        <h1
          className="text-white font-[500] mb-10 text-center truncate"
          style={{
            fontFamily: 'Bricolage Grotesque',
            fontWeight: 500,
            fontSize: '4vw',
            lineHeight: '80px',
            letterSpacing: '-1%',
            maxWidth: 1360,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          AI founders said it better than we ever could
        </h1>
        <div className="flex flex-row gap-6 mb-16 w-full justify-center flex-wrap">
          {BUTTONS.map((btn, i) => (
            <div
              key={i}
              className="flex flex-col justify-center items-center rounded-lg"
              style={{
                background: 'rgba(234, 247, 39, 1)',
                width: '100%',
                maxWidth: 300,
                minWidth: 180,
                height: 80,
                padding: '12px 20px',
              }}
            >
              <div className="flex flex-row items-center gap-2 w-full justify-center">
                <span
                  style={{
                    fontFamily: 'Bricolage Grotesque',
                    fontWeight: 700,
                    fontSize: '2rem',
                    lineHeight: '38px',
                    color: 'rgba(24, 24, 27, 1)',
                    marginBottom: 0,
                  }}
                >
                  {btn.label}
                </span>
                <span
                  style={{
                    fontFamily: 'Space Grotesk',
                    fontWeight: 500,
                    fontSize: '1rem',
                    lineHeight: '24px',
                    color: 'rgba(24, 24, 27, 1)',
                    marginTop: 0,
                    whiteSpace: 'normal',
                    display: 'inline-block',
                  }}
                  dangerouslySetInnerHTML={{ __html: btn.sub }}
                />
              </div>
            </div>
          ))}
        </div>
        {/* Video - rectangle, overlaps black and white sections */}
        <div className="w-full flex justify-center relative z-10" style={{ marginTop: 0 }}>
          <div
            className="rounded-xl overflow-hidden border border-[#7B61FF] shadow-lg bg-white"
            style={{
              width: 1489.82,
              height: 636,
              minWidth: 320,
              minHeight: 200,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/6aqnYDehMMk?si=xdNWyYjAl7vPKxUz"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{ minHeight: 200, background: '#000', width: '100%', height: '100%' }}
            ></iframe>
          </div>
        </div>
        {/* About the client section */}
        <div className="w-full flex flex-col items-center mt-16">
          <div className="w-full max-w-2xl mx-auto">
            <h2
              style={{
                fontFamily: 'Bricolage Grotesque',
                fontWeight: 700,
                fontSize: '2.2rem',
                lineHeight: '38px',
                color: 'rgba(24, 24, 27, 1)',
                letterSpacing: 0,
                verticalAlign: 'middle',
                marginBottom: 24,
                width: 702,
                maxWidth: '100%',
              }}
            >
              About the client
            </h2>
            <p className="mb-8 text-black" style={{fontSize: '1.1rem', lineHeight: '1.6'}}>
              Dealing with emails can get exhausting when you’re dealing with high volumes.<br/>
              This goes especially if you are a stakeholder or any type of manager.<br/>
              An inbox cluttered with requests, updates, and confirmations is a problem you’re guaranteed to run into sooner or later.<br/>
              With Thun.ai, we’ve replied to over 200 emails in under 2 hours which reduces how overwhelming switching tasks can get.
            </p>
            {/* Smaller video */}
            <div className="w-full flex justify-center mb-16">
              <div
                className="rounded-xl overflow-hidden border border-[#7B61FF] shadow-lg bg-white"
                style={{
                  width: 850,
                  height: 456,
                  maxWidth: '100%',
                  minWidth: 320,
                  minHeight: 200,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/6aqnYDehMMk?si=xdNWyYjAl7vPKxUz"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{ minHeight: 200, background: '#000', width: '100%', height: '100%' }}
                ></iframe>
              </div>
            </div>
            {/* The Challenge */}
            <div className="w-full max-w-[850px] mx-auto mb-12">
              <div className="flex items-center gap-4 mb-4"><img src={challenge} alt="Challenge" style={{width:48, height:48}} /><h2 style={{fontFamily: 'Bricolage Grotesque', fontWeight: 700, fontSize: '2.2rem', lineHeight: '38px', color: '#18181B'}} >The Challenge</h2></div>
              <p style={{fontFamily: 'Inter', fontWeight: 400, fontSize: 24, lineHeight: '32px', color: '#18181B'}}>
                Recently, we got a request for a PR post we were interested in.<br/>
                But, to help you get a better idea, we went ahead and recorded the process of just how we automate drafting our replies.<br/>
                Since we were interested in the request, we generated the response using Thunai 10X faster than we would normally.<br/><br/>
                Dealing with emails can get exhausting when you’re dealing with high volumes.<br/>
                This goes especially if you are a stakeholder or any type of manager.<br/>
                An inbox cluttered with requests, updates, and confirmations is a problem you’re guaranteed to run into sooner or later.<br/>
                With Thunai, we’ve replied to over 200 emails in under 2 hours which reduces how overwhelming switching tasks can get.
              </p>
            </div>
            {/* The Solution */}
            <div className="w-full max-w-[850px] mx-auto mb-12">
              <div className="flex items-center gap-4 mb-4"><img src={solution} alt="Solution" style={{width:48, height:48}} /><h2 style={{fontFamily: 'Bricolage Grotesque', fontWeight: 700, fontSize: '2.2rem', lineHeight: '38px', color: '#18181B'}} >The Solution</h2></div>
              <p style={{fontFamily: 'Inter', fontWeight: 400, fontSize: 24, lineHeight: '32px', color: '#18181B'}}>
                With Thunai, users can use the extension in browsers to draft and customize emails based on their existing Thunai knowledge base.<br/><br/>
                What does that mean? Well, based on past conversations, the files you’ve uploaded or links you have given Thunai access to, it becomes a knowledge base that is up to date with all your work or any type of information you permit.<br/><br/>
                Once you do this, you can use Thunai to automate this process, but you only need to add minor changes or input when drafting your emails.<br/>
                Recently, we got a request for a PR post we were interested in.<br/>
                But, to help you get a better idea, we went ahead and recorded the process of just how we automate drafting our replies.<br/>
                Since we were interested in the request, we generated the response using Thunai 10X faster than we would normally.
              </p>
            </div>
            {/* The Outcome */}
            <div className="w-full max-w-[850px] mx-auto mb-12">
              <div className="flex items-center gap-4 mb-4"><img src={outcome} alt="Outcome" style={{width:48, height:48}} /><h2 style={{fontFamily: 'Bricolage Grotesque', fontWeight: 700, fontSize: '2.2rem', lineHeight: '38px', color: '#18181B'}} >The Outcome</h2></div>
              <p style={{fontFamily: 'Inter', fontWeight: 400, fontSize: 24, lineHeight: '32px', color: '#18181B'}}>
                With Thunai, users can use the extension in browsers to draft and customize emails based on their existing Thunai knowledge base.<br/><br/>
                What does that mean? Well, based on past conversations, the files you’ve uploaded or links you have given Thunai access to, it becomes a knowledge base that is up to date with all your work or any type of information you permit.<br/><br/>
                Once you do this, you can use Thunai to automate this process, but you only need to add minor changes or input when drafting your emails.<br/>
                Recently, we got a request for a PR post we were interested in.<br/>
                But, to help you get a better idea, we went ahead and recorded the process of just how we automate drafting our replies.<br/>
                Since we were interested in the request, we generated the response using Thunai 10X faster than we would normally.
              </p>
            </div>
            {/* Why founders trust Payan? */}
            <div className="w-full max-w-[850px] mx-auto mb-12">
              <div className="flex items-center gap-4 mb-4"><img src={payan} alt="Payan" style={{width:48, height:48}} /><h2 style={{fontFamily: 'Bricolage Grotesque', fontWeight: 700, fontSize: '2.2rem', lineHeight: '38px', color: '#18181B'}} >Why founders trust Payan?</h2></div>
              <p style={{fontFamily: 'Inter', fontWeight: 400, fontSize: 24, lineHeight: '32px', color: '#18181B'}}>
                With Thunai, users can use the extension in browsers to draft and customize emails based on their existing Thunai knowledge base.<br/><br/>
                What does that mean? Well, based on past conversations, the files you’ve uploaded or links you have given Thunai access to, it becomes a knowledge base that is up to date with all your work or any type of information you permit.<br/><br/>
                Once you do this, you can use Thunai to automate this process, but you only need to add minor changes or input when drafting your emails.<br/>
                Recently, we got a request for a PR post we were interested in.<br/>
                But, to help you get a better idea, we went ahead and recorded the process of just how we automate drafting our replies.<br/>
                Since we were interested in the request, we generated the response using Thunai 10X faster than we would normally.
              </p>
            </div>
            {/* Case Study Button */}
            <div className="w-full flex justify-center mt-12">
              <button
                style={{
                  width: 604,
                  height: 110,
                  borderRadius: 10,
                  padding: '18px 34px',
                  background: 'rgba(0, 0, 0, 1)',
                  color: 'rgba(255, 255, 255, 1)',
                  marginBottom: 90,
                  fontFamily: 'Space Grotesk',
                  fontWeight: 700,
                  fontSize: 32,
                  lineHeight: '100%',
                  letterSpacing: 0,
                  textTransform: 'capitalize',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 10,
                }}
              >
                See Next Case Study
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* Section 2: Full black for InteractiveTab and footer */}
    <section className="w-full bg-black flex flex-col items-center py-16 px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24 ">
      <h2
          className="text-white text-left w-full"
          style={{
            fontFamily: 'Bricolage Grotesque',
            fontWeight: 500,
            fontSize: '48px',
            marginBottom: 40,
            lineHeight: '60px',
            letterSpacing: '-1%',
            maxWidth: 1143,
          }}
        >
          Ready to turn your website or<br/>GTM assets into a growth engine?
        </h2>
      <div className="w-full max-w-screen-xl mx-auto">
        <InteractiveTab />
      </div>
    </section>
  </Layout>
);

export default SuccessPage; 